<template>
  <div id="app">
	<router-view></router-view>
  </div>
</template>
<style>
	
html,body,#app{height:100%;margin:0;padding:0;}
/*固定宽度的div*/
.sameWidth {
	width: 1150px;
	position: relative;
	left: 50%;
	margin-left: -575px !important;
	box-sizing: border-box;
}
</style>
<script>
	export default {
		name: 'app',
	}
</script>